module.exports = __webpack_public_path__ + "media/images/pc/croud-85c08056c7e0ba83a0caa01fa1257cf7.png";